export const ADD_MENU_FEATURE = "ADD_MENU_FEATURE"
export const ADD_MENU_FEATURE_SUCCESS = "ADD_MENU_FEATURE_SUCCESS"
export const ADD_MENU_FEATURE_FAILED = "ADD_MENU_FEATURE_FAILED"

export const GET_MENU_ICONS = "GET_MENU_ICONS"
export const GET_MENU_ICONS_SUCCESS = "GET_MENU_ICONS_SUCCESS"
export const GET_MENU_ICONS_FAILED = "GET_MENU_ICONS_FAILED"

export const OPEN_SELECT_ICON_MODAL = "OPEN_SELECT_ICON_MODAL"
export const HIDE_SELECT_ICON_MODAL = "HIDE_SELECT_ICON_MODAL"

export const EDIT_MENU_ITEM = "EDIT_MENU_ITEM"
export const EDIT_MENU_ITEM_SUCCESS = "EDIT_MENU_ITEM_SUCCESS"
export const EDIT_MENU_ITEM_FAILED = "EDIT_MENU_ITEM_FAILED"

export const DELETE_MENU_ITEM = "DELETE_MENU_ITEM"
export const DELETE_MENU_ITEM_SUCCESS = "DELETE_MENU_ITEM_SUCCESS"
export const DELETE_MENU_ITEM_FAILED = "DELETE_MENU_ITEM_FAILED"

export const OPEN_DELETE_FEATURE_MODAL = "OPEN_DELETE_FEATURE_MODAL"
export const HIDE_DELETE_FEATURE_MODAL = "HIDE_DELETE_FEATURE_MODAL"

export const PUT_MENU_ITEM_SUCCESS = "PUT_MENU_ITEM_SUCCESS"

export const SHOW_SAVING_MODAL = "SHOW_SAVING_MODAL"
export const HIDE_SAVING_MODAL = "HIDE_SAVING_MODAL"

export const SET_ISOUTDATED = "SET_ISOUTDATED"
export const SET_SELECTED_FEATURE = "SET_SELECTED_FEATURE"

export const UPLOAD_MENU_ITEM_IMAGE = "UPLOAD_MENU_ITEM_IMAGE"
export const UPLOAD_MENU_ITEM_IMAGE_SUCCESS = "UPLOAD_MENU_ITEM_IMAGE_SUCCESS"
export const UPLOAD_MENU_ITEM_IMAGE_FAILED = "UPLOAD_MENU_ITEM_IMAGE_FAILED"

export const OPEN_NOTIFICATION_POPUP = "OPEN_NOTIFICATION_POPUP"
export const HIDE_NOTIFICATION_POPUP = "HIDE_NOTIFICATION_POPUP"

export const GET_FEATURE_DEEPLINK_URL = "GET_FEATURE_DEEPLINK_URL"
export const GET_FEATURE_DEEPLINK_URL_SUCCESS =
  "GET_FEATURE_DEEPLINK_URL_SUCCESS"
export const GET_FEATURE_DEEPLINK_URL_FAILED = "GET_FEATURE_DEEPLINK_URL_FAILED"

export const GET_FEATURE_DEEPLINK_CODES = "GET_FEATURE_DEEPLINK_CODES"
export const GET_FEATURE_DEEPLINK_CODES_SUCCESS =
  "GET_FEATURE_DEEPLINK_CODES_SUCCESS"
export const GET_FEATURE_DEEPLINK_CODES_FAILED =
  "GET_FEATURE_DEEPLINK_CODES_FAILED"

export const OPEN_GENERATE_FEATURE_DEEPLINK_MODAL =
  "OPEN_GENERATE_FEATURE_DEEPLINK_MODAL"
export const HIDE_GENERATE_FEATURE_DEEPLINK_MODAL =
  "HIDE_GENERATE_FEATURE_DEEPLINK_MODAL"

export const CLONE_MENU_FEATURE = "CLONE_MENU_FEATURE"
export const CLONE_MENU_FEATURE_SUCCESS = "CLONE_MENU_FEATURE_SUCCESS"
export const CLONE_MENU_FEATURE_FAILED = "CLONE_MENU_FEATURE_FAILED"

export const DISPLAY_LOCK_WARNING_MODAL = "DISPLAY_LOCK_WARNING_MODAL"
export const HIDE_LOCK_WARNING_MODAL = "HIDE_LOCK_WARNING_MODAL"

export const SET_MENU_FEATURE_UPDATE_LOADING = "SET_MENU_FEATURE_UPDATE_LOADING"

export const OPEN_FEATURE_NOTIFICATION_MODAL = "OPEN_FEATURE_NOTIFICATION_MODAL"
export const HIDE_FEATURE_NOTIFICATION_MODAL = "HIDE_FEATURE_NOTIFICATION_MODAL"
